<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container >
      <a-form-model ref="formTitle" :model="model" :rules="validatorRules" slot="detail">
        <a-row>
          <!--<a-col :span="24">
            <a-form-model-item :label="language['emp.col.entrance.entranceName']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="entranceId" >
              <a-select v-model="model.entranceId" @change="entranceChange" :placeholder="language['common.pleaseChoose']+language['emp.col.entrance.entranceName']" allowClear :disabled="isDisable">
                <a-select-option v-for="(item,index) in entrancelist" :key="index.toString()" :value="item.id"  >
                  {{ item.entranceName }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" :label="language['emp.content.field']" prop="firstColId">
              <a-select allowClear :placeholder="language['column.pleaseChoose']+language['emp.content.field']" v-model="model.firstColId" @change="colChange" allowClear :disabled="isDisable" >
                <a-select-option v-for="(item,index) in cols" :key="index.toString()" :value="item.id">
                  {{ item.colName }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="24" v-if="isShowClassification">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" :label="language['emp.col.colLevel_two']" >
              <a-select allowClear :placeholder="language['column.pleaseChoose']+language['emp.col.colLevel_two']" v-model="classificationId" @change="classificationChange" allowClear :disabled="isDisable">
                <a-select-option v-for="(item,index) in classifications" :key="index.toString()" :value="item.id">
                  {{ item.colName }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>-->
          <a-col :span="24">
            <a-form-model-item :label="language['emp.content.contentPath']" :labelCol="labelCol" :wrapperCol="wrapperCol"  >
              <!--<a-input v-model="contentPath"  style="width: 80%" :disabled="true"></a-input>-->
              <a-span>{{contentPath}}</a-span>
              <!--<a-select v-model="model.entranceId" @change="entranceChange" :placeholder="language['common.pleaseChoose']+language['emp.col.entrance.entranceName']" allowClear :disabled="isDisable">
                <a-select-option v-for="(item,index) in entrancelist" :key="index.toString()" :value="item.id"  >
                  {{ item.entranceName }}
                </a-select-option>
              </a-select>-->
            </a-form-model-item>
          </a-col>

          <a-col :span="24" v-if="!!id">
            <a-form-model-item :label="language['emp.content.number']" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-model="contentCode"   :disabled="formDisabled"></a-input>
            </a-form-model-item>
          </a-col>
          <!--<a-col :span="24" >
            <a-form-model-item :label="language['emp.content.isfile']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="isFilecontent">
              <a-radio-group v-model="model.isFilecontent" @change="filecontentChange" :disabled="formDisabled">
                <a-radio value="1" @click="contentTypeCh(false)">{{ language['common.yes'] }}</a-radio>
                <a-radio value="0" @click="contentTypeCh(true)">{{ language['common.no']}}</a-radio>
              </a-radio-group>
            </a-form-model-item>
          </a-col>-->
          <!--<a-col :span="24" >
            <a-form-model-item :label="language['hhemp.is.watermarked']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="isWatermark">
              <a-radio-group v-model="model.isWatermark"  :disabled="formDisabled" >
                <a-radio value="1" >{{ language['common.yes'] }}</a-radio>
                <a-radio value="0" >{{ language['common.no']}}</a-radio>
              </a-radio-group>
            </a-form-model-item>
          </a-col>-->

          <!--<a-col :span="24" >
            <a-form-model-item :label="language['emp.col.pushSso']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="pushSso">
              <a-radio-group v-model="model.pushSso"  :disabled="formDisabled" >
                <a-radio value="0" >{{ language['common.no']}}</a-radio>
                <a-radio value="1" >{{ language['common.yes'] }}</a-radio>
              </a-radio-group>
            </a-form-model-item>
          </a-col>-->
        </a-row>
      </a-form-model>
      <a-row slot="detail">
        <a-form-model-item :label="'內容詳情'" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-checkbox-group v-model="contentLangCodes" @change="languageCodeChange" :disabled="formDisabled">
            <a-checkbox v-for="(item, index)  in langList" :key="item.value" :value="item.value"><span style="color: #3260c9;">{{ language[item.value] }}</span></a-checkbox>
          </a-checkbox-group>
          <a-tabs  style="border: 1px solid #262626;border-radius: 5px;" disabled="false" @change="changeTabs" :activeKey="this.TabsActiveKey" default-active-key="1" :disabled="formDisabled"><!--:activeKey="TabsActiveKey"-->
            <a-tab-pane :tab="language[item.value]" :key="index" v-for="(item, index) in contentLanglist" v-if="contentLangCodes.indexOf(item.value)!=-1"><!--model.detailsList-->
              <a-form-model ref="form" :model="item" :rules="validatorRules">
                <a-row>
                  <a-form-model-item :label="language['emp.content.model5.serviceName']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="serviceName">
                    <a-input v-model="item.serviceName" :placeholder="language['ad.must']+language['emp.content.model5.serviceName']"  style="width: 80%" :disabled="formDisabled"></a-input>
                  </a-form-model-item>
                  <a-form-model-item :label="language['emp.content.model5.serviceUrl']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="serviceUrl">
                    <a-input v-model="item.serviceUrl" :placeholder="language['ad.must']+language['emp.content.model5.serviceUrl']"  style="width: 80%" :disabled="formDisabled"></a-input>
                  </a-form-model-item>
                  <a-form-model-item :label="language['emp.content.model5.defaultImgUrl']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="defaultImgUrl" >
                    <j-image-upload class="avatar-uploader" :text="language['common.uploadButton']" v-model="item.defaultImgUrl" :upload-source="uploadSource"  :disabled="formDisabled"></j-image-upload>
                  </a-form-model-item>
                  <a-form-model-item :label="language['emp.content.model5.hoverImgUrl']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="hoverImgUrl" >
                    <j-image-upload class="avatar-uploader" :text="language['common.uploadButton']" v-model="item.hoverImgUrl" :upload-source="uploadSource"  :disabled="formDisabled"></j-image-upload>
                  </a-form-model-item>
                  <!--<a-form-model-item :label="language['emp.content.answer']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="answer">
                    <j-editor v-if="langCodeValue=='zh_CN'||langCodeValue=='zh_TW'" v-model="item.answer" :languageCode="`zh_CN`" :disabled="formDisabled"/>
                    <j-editor v-else v-model="item.answer" :languageCode="`en_US`" :disabled="formDisabled"/>
                  </a-form-model-item>-->
                  <!--<a-form-model-item :label="language['emp.content.image']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="imgUrl" >
                    <j-image-upload class="avatar-uploader" :text="language['common.uploadButton']" v-model="item.imgUrl" :upload-source="uploadSource"  :disabled="formDisabled"></j-image-upload>
                  </a-form-model-item>-->
                  <!--<a-form-model-item :label="language['emp.develop.contDetail']" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <div v-if="contentTypeChecked">
                      <j-editor v-if="langCodeValue=='zh_CN'||langCodeValue=='zh_TW'" v-model="item.contentDetails" :languageCode="`zh_CN`" :disabled="formDisabled"/>
                      <j-editor v-else v-model="item.contentDetails" :languageCode="`en_US`" :disabled="formDisabled"/>
                    </div>
                    <div v-if="contentFileChecked||contentTypeChecked">
                      <j-upload file-type="file" :uploadSource="`hhemp`" bizPath="null" :button-style="`color: #fff;background-color: #3260c9;`"
                                :newWindowOpen="`true`" v-model="item.filePath"
                                :disabled="formDisabled" @change="handleChange"
                                :number="0" :multiple="true"> </j-upload>
                    </div>
                  </a-form-model-item>-->
                </a-row>
              </a-form-model>
            </a-tab-pane>
          </a-tabs>
        </a-form-model-item>
      </a-row>
      <a-form-model ref="formOther" :model="model" :rules="validatorRules" slot="detail">
        <a-row>
          <a-col :span="24">
            <a-form-model-item :label="language['emp.col.sortNo']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="sortNo">
              <a-input-number :min="1" :max="999999" v-model="model.sortNo"  style="width: 100%" :placeholder="language['common.pleaseInput']+language['emp.col.sortNo']" :disabled="this.disabled"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item :label="language['emp.col.colLevel']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="contentType" >
              <j-dict-select-tag type="list" v-model="model.contentType" dictCode="emp_content_type" :disabled="formDisabled" allowClear/>
            </a-form-model-item>
          </a-col>
          <!--<a-col :span="24">
            <a-form-model-item :label="language['legalperson']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="legalPerson" >
              <j-multi-select-tag type="checkbox" v-model="model.legalPerson" dictCode="emp_legal" :disabled="formDisabled" allowClear/>
            </a-form-model-item>
          </a-col>-->
          <a-col :span="24" v-if="this.$store.getters.applicationCode=='hhemp'">
            <a-form-model-item :label="language['legalperson']" :labelCol="labelCol" :wrapperCol="wrapperCol"  >
              <!--<j-multi-select-tag type="checkbox" v-model="model.legalPerson" dictCode="emp_legal" :disabled="formDisabled" allowClear/>-->
              <!--@change="legalPersonChange"-->
              <!--<a-checkbox-group v-model="contentlegalPerson" @change="legalPersonChange">
                  <a-checkbox v-for="(item, index)  in legalpersonList" :key="index" :value="item.value" :disabled="item.type=='0'"><span style="color: #3260c9;">{{ item.text }}</span></a-checkbox>
              </a-checkbox-group>-->
              <a-radio-group v-model="contentlegalPerson"  :disabled="formDisabled||!!model.id" @change="legalPersonChange">
                <template v-for="(item, index)  in legalpersonList" >
                  <template >
                    <span v-if="index!=0" style="padding-right: 20px;padding-left:10px">|</span>
                    <a-radio :value="item.value"><span style="color: #3260c9;">{{ item.text }}</span></a-radio>
                    <template  v-if="contentlegalPerson==item.value">(<a-checkbox v-model="withOutsourcing" :disabled="formDisabled||!!model.id"><span style="color: #3260c9;">{{language["emp.content.legalperson_withOutsourcing"]}}</span> </a-checkbox>)</template>
                  </template>
                </template>
              </a-radio-group>
              <!--<a-checkbox v-model="contentlegalPerson1" :value="item.value+'_withOutsourcing'" v-if="contentlegalPerson.indexOf(item.value)!=-1">要派公司 </a-checkbox>-->

              <!--<a-checkbox-group v-model="model.legalPerson">
                <a-checkbox v-for="(item, index)  in langList" :value="item.value"><span style="color: #3260c9;">{{ language[item.value] }}</span></a-checkbox>
              </a-checkbox-group>-->
            </a-form-model-item>
          </a-col>
          <div v-if="this.$store.getters.applicationCode=='vnemp'">
            <a-col :span="24">
              <a-form-model-item :label="language['emp.content.bu']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="factoryCode">
                <j-multi-select-tag type="checkbox" v-model="model.factoryCode" class="factoryClass" style="margin-top: 10px" :dictCode="this.$store.getters.applicationCode+'_content_factory'"  :disabled="formDisabled" />
              </a-form-model-item>
            </a-col>
          </div>
          <div v-else>
            <a-col :span="24">
              <a-form-model-item :label="language['emp.content.factoryCode']" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <j-multi-select-tag type="checkbox" v-model="model.factoryCode"  :dictCode="this.$store.getters.applicationCode+'_content_factory'"  :disabled="formDisabled" />
              </a-form-model-item>
            </a-col>
            <a-col :span="24">
              <a-form-model-item :label="language['emp.content.bg']" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <j-multi-select-tag type="checkbox" v-model="model.bg" :dictCode="this.$store.getters.applicationCode+'_content_bg'"  :disabled="formDisabled" />
              </a-form-model-item>
            </a-col>
          </div>
          <a-col :span="24">
            <a-form-model-item :label="language['platform.roleUser.columns2.status']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="publishStatus">
              <j-dict-select-tag v-model="model.publishStatus" :type="'radio'" dictCode="hhemp_publish_status"  disabled />
            </a-form-model-item>
          </a-col>
          <div >
            <a-col :span="24">
              <a-form-model-item :label="language['emp.col.publishTime']" :labelCol="labelCol" :wrapperCol="wrapperCol"  >
                <j-date placeholder="" v-model="model.publishTimeHand"  style="width: 100%"  date-format="YYYY-MM-DD HH:mm:ss" :disabled="formDisabled" />
              </a-form-model-item>
            </a-col>
          </div>
          <a-col :span="24" v-if="model.publishStatus=='published'">
            <a-form-model-item :label="language['emp.col.publisher']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="publisher" v-show="colVisible==true">
              <a-input v-model="model.publisher" placeholder=""  :readOnly="true" disabled></a-input>
            </a-form-model-item>
          </a-col>

          <div >
            <a-col :span="24" v-if="model.publishStatus=='published'">
              <a-form-model-item :label="language['emp.listing.time']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="publishTime" v-show="colVisible==true">
                <j-date placeholder="" v-model="model.publishTime"  style="width: 100%"  date-format="YYYY-MM-DD HH:mm:ss" :disabled="true"/>
              </a-form-model-item>
            </a-col>
          </div>




         <!-- <a-col :span="24">
            <a-form-model-item :label="language['emp.develop.contDetail']" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-tabs defaultActiveKey="1" style="border: 1px solid #262626;border-radius: 5px;" disabled="false">

                <a-tab-pane :tab="language[item.value]" :key="index" v-for="(item, index) in langList">
                  <div v-if="contentTypeChecked">
                    <j-editor v-if="langCodeValue=='zh_CN'||langCodeValue=='zh_TW'" v-model="model[item.content]" :languageCode="`zh_CN`"/>
                    <j-editor v-else v-model="model[item.content]" :languageCode="`en_US`"/>
                  </div>
                    <div v-if="contentFileChecked||contentTypeChecked" class="upload-class">
                      <j-upload file-type="file" :uploadSource="`hhemp`" bizPath="null"
                                :newWindowOpen="`true`" v-model="model[item.filePath]"
                                :disabled="disabled" @change="handleChange"
                                :number="0" :multiple="true"> </j-upload>
                    </div>

                </a-tab-pane>
              </a-tabs>
            </a-form-model-item>

          </a-col>-->
        </a-row>
      </a-form-model>
      <language-model ref="languageModel" @ok="languageOk"></language-model>
    </j-form-container>
  </a-spin>
</template>

<script>

  import { httpAction, getAction } from '@/api/manage'
  import { validateDuplicateValue } from '@/utils/util'
  import JEditor from '@/components/jeecg/JEditor'
  import LanguageModel from "@/components/LanguageModel"
  import { USER_LANGUAGE } from "@/store/mutation-types"
  import { getDictItemValuesFromCache } from '@/api/api'
  import Vue from 'vue'
  // import moment from "moment";
  export default {
    name: 'CmsContentTblForm5',
    components: {
      JEditor,
      LanguageModel
    },
    props: {
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      },
      contentPath:String,
        colidProps: String,
      pageLangCode: String,
    },
    data () {
      const { language } = this.$store.getters;
      return language &&  {
        isDisable:false,
        value:"222",
        model:{
            // cnData:{content:""},
            // twData:{content:""},
            // enData:{content:""}
         },
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        validatorRules: {
          entranceId:[
            { required: true, message: language['common.pleaseChoose']+language['emp.col.entrance.entranceName']},
          ],
          firstColId: [
              { required: true, message: language['column.pleaseChoose']+language['emp.content.field']},
           ],
          serviceName:[
            { required: true, message: language['ad.must']+language['emp.content.model5.serviceName']},
          ],
          serviceUrl: [
              { required: true, message: language['ad.must']+language['emp.content.model5.serviceUrl']},
           ],
          answer: [
            { required: true, message: language['ad.must']+language['emp.content.answer']},
          ],
          defaultImgUrl: [
              { required: true, message: language['emp.content.model5.defaultImgUrl']+language['common.cannotEmpty']},
           ],
          hoverImgUrl: [
            { required: true, message: language['emp.content.model5.hoverImgUrl']+language['common.cannotEmpty']},
          ],
           sortNo: [
            {required: true, message: language['common.pleaseInput']+language['emp.col.sortNo']},
           /* {validator: this.validateToSortNo, trigger: 'blur'}*/
           ],
           isThird: [
              { required: true, message: '请选择是否第三方内容!'},
           ],
          isFilecontent:[
            { required: true, message: language['common.pleaseChoose']+language['emp.content.isfile']},
          ],
          isWatermark:[
            { required: true, message: language['common.pleaseChoose']+language['hhemp.is.watermarked']},
          ],
          pushSso:[
            { required: true, message: language['common.pleaseChoose']+language['emp.col.pushSso']},
          ],
          publishTime: [
            { required: true, message: language['common.pleaseChoose']+language['emp.col.publishTime']},
          ],
          legalPerson: [
            { required: true, message: language['common.pleaseChoose']+language['legalperson']},
          ],
          factoryCode:[
            { required: true, message: language['common.pleaseChoose']+language['emp.content.bu']},
          ]
           /*publishStatus: [
              { required: true, message: '请输入发布状态!'},
           ],
           delFlag: [
              { required: true, message: '请输入刪除标示!'},
           ],*/
        },
        url: {
          add: "/hhemp/content/cmscontenttbl",
          edit: "/hhemp/content/cmscontenttbl",
          queryById: "/hhemp/content/cmscontenttbl/"
        },
        uploadSource: 'hhemp',
        colVisible: false,
        cols:[],
        entrancelist:[],
        entranceId:'',
        colId:"",
        classificationId:'',
        classifications:[],
        isShowClassification:'',
        contentTypeChecked:false,
        contentFileChecked:true,
        langList:[],
        contentTitleLanguages:[],
        contentSubTitleLanguages:[],
        remarkLanguages:[],
        langCodeValue:'',

        // contentPath:"",
        contentLangCodes:[],
        contentLangCodesOld:[],
        contentLanglist:[],
        empContentDetails:[],
        TabsActiveKey:-1,
        legalpersonList:[],
        contentlegalPerson:'',
        withOutsourcing:false,
      }
    },
    computed: {
      formDisabled(){
        return this.disabled
      },
      language() {
        return this.$store.getters.language
      },
    },
    created () {
      this.langCodeValue = window.sessionStorage.getItem(USER_LANGUAGE)
      // this.initLangListData();
       //备份model原始值
      this.modelDefault = JSON.parse(JSON.stringify(this.model));
      // this.initEntrancelist();
    },
    methods: {
      // moment,
      legalPersonChange(data){
        this.withOutsourcing = true;
      },
      languageCodeChange(data){
        if(data.length!=0){
          let changeValue = ""
          if(this.contentLangCodesOld.length!=0){
            let oldlist = [...this.contentLangCodesOld];
            for(let i=0;i<oldlist.length;i++){
              if(data.indexOf(oldlist[i])==-1){
                changeValue = oldlist[i];
              }
            }
          }else{
            changeValue = data[0]
          }
          let indexNumber = -1
          let list = [...this.langList]
          for(let i=0;i<list.length;i++){
            let item = list[i];
            if(item.value==changeValue){
              indexNumber = i;
            }
          }
          if(this.contentLangCodesOld.length>this.contentLangCodes.length){
            if(this.TabsActiveKey==indexNumber){
              if(this.TabsActiveKey==0){
                this.TabsActiveKey++
              }else{
                this.TabsActiveKey--
              }
            }
          }else{
            if(this.TabsActiveKey == -1)this.TabsActiveKey = indexNumber
          }
          /*let list = [...this.contentLanglist]
          for (let j=0;j<data.length;j++){
            for(let i=0;i<list.length;i++){
              let item = list[i];
              if(item.value==data[j]){
                list.splice(i,1)
              }
            }
          }
          if(list.length!=0){
            list.forEach(o=>{
              if(o.indexValue == this.TabsActiveKey){
                this.TabsActiveKey--;
              }
            })
          }*/
        }else{
          this.TabsActiveKey = -1
        }
        this.contentLangCodesOld = this.contentLangCodes
      },
      changeTabs(key){
        this.TabsActiveKey = key;
      },
      initLangListData(){
        let that=this;
        //从缓存中获取数据模板多语言
        // that.langList= [...that.$store.getters.languagelist];
        let initLanguageList=[];
        that.$store.getters.languagelist.forEach(item => {
          // let foundObject = that.langList.find(function(obj) {
          //   return obj.value === item.value;
          // });
          let map = JSON.parse(JSON.stringify(item));
          if(map.value == this.pageLangCode){
            initLanguageList.unshift(map)
          }else{
            initLanguageList.push(map);
          }
        })

        this.langList=initLanguageList;
      },
      contentTypeCh(tag){
        if(tag){
          this.contentTypeChecked=true;
          this.contentFileChecked=false;
        }else{
          this.contentTypeChecked=false;
          this.contentFileChecked=true;
        }
      },
      /*initLanguagetemp(dataTable, dataColumn, dataId) {
        getAction("/sys/syslanguagedata/querylistby", {
          applicationCode: "hhemp",
          dataTable: dataTable,
          dataColumn: dataColumn,
          dataId: dataId
        }).then((res) => {
          if (res.success) {
            if (dataColumn == 'contentTitle') {
              this.contentTitleLanguages = res.result;
            } else if (dataColumn == 'contentSubTitle') {
              this.contentSubTitleLanguages = res.result;
            } else if (dataColumn == 'remark') {
              this.remarkLanguages = res.result;
            }
          }
        })
      },*/
      languageOk(map) {
        console.log("map:",map)
        if (map && map.dataColumn == 'contentTitle') {
          this.contentTitleLanguages = map.languagelist;
        } else if (map && map.dataColumn == 'contentSubTitle') {
          this.contentSubTitleLanguages = map.languagelist;
        }else if (map && map.dataColumn == 'remark') {
          this.remarkLanguages = map.languagelist;
        }
      },
      /*languageModelOpen(dataTable, dataColumn, languagelist) {
        this.$refs.languageModel.edit("hhemp", dataTable, dataColumn, this.model.id, languagelist, this.disabled);
      },*/
      handleChange(value,files){
        console.log(value,files)
      },
      /*entranceChange(v){
        this.entranceId = v;
        this.model.colId = '';
        this.model.firstColId='';
        this.classificationId='';
        this.getColList();
      },*/
      /*initEntrancelist(){
        getAction("/hhemp/entrance/empcmsentrances",{"status":"Y"}).then(res=>{
          if(res.success){
            this.entrancelist = res.result;
          }
        })
      },*/
      initLegalpersonList(){
        let that = this
        that.contentlegalPerson = '';
        httpAction("/hhemp/colManagerLegal/getLegalpersonListByColId?colId="+that.colidProps, {colId:that.colidProps}, "get").then((res) => {
          if (res.success) {
            that.legalpersonList = []
            res.result.forEach(item=>{
              that.legalpersonList.push({value:item.legalpersonCode,text:item.legalpersonName,type:"0"})

              // that.legalpersonList.push({value:item.legalpersonCode+"_withOutsourcing",text:item.legalpersonName+this.language["emp.content.legalperson_withOutsourcing"],type:"1"})
              // that.contentlegalPerson.push(item.legalpersonCode)
            })
            if(!!that.model.id){
              // that.model.legalPersonlist = [...that.contentlegalPerson];
              // that.contentlegalPerson = [...that.model.legalPersonValuelist]
              that.model.legalPersonlist.forEach(item=>{
                that.contentlegalPerson=item.legalpersonCode;
                if(item.isWithOutsourcing=='1'){
                  that.withOutsourcing = true
                }else{
                  that.withOutsourcing = false
                }
              })
            }else{
              if(that.legalpersonList.length!=0){
                that.contentlegalPerson=that.legalpersonList[0].value;
              }
              that.withOutsourcing = true;
            }
            /*let value = "";
            res.result.forEach(item=>{
              if(value!=""){
                value = value+","+item.legalpersonCode
              }else{
                value = item.legalpersonCode
              }
            })
            that.model.legalPerson = value*/
          }
        })
      },
      /*initContentPath(){
        let that = this
        httpAction("/hhemp/col/cmscoltbl/"+that.colidProps, "", "get").then((res) => {
          if (res.success) {
            that.contentPath = res.result.entranceName+">"+res.result.colPath;

          }
        })
      },*/
      /*initCol(colId,colName){
        httpAction("/hhemp/col/cmscoltbl/"+colId, "", "get").then((res) => {
          if (res.success) {
            this.contentPath = this.contentPath+">"+res.result.colNameLangCodeValue+">"+colName;
          }
        })
      },*/
      add () {
        //this.edit(this.modelDefault);
        // this.edit({publishStatus:'unpublished',isFilecontent:"1",isThird:'0',isWatermark:"1",pushSso:"1",publishTimeHand:this.moment(new Date()).format('yyyy-MM-dd hh:mm:ss')});
        let param = {publishStatus:'unpublished',isFilecontent:"1",isThird:'0',isWatermark:"1",pushSso:"1",publishTimeHand:this.getNowTime()}
        if(this.$store.getters.applicationCode == 'vnemp'){
          let factoryCodes = getDictItemValuesFromCache(this.$store.getters.applicationCode+'_content_factory')
          param.factoryCode = factoryCodes.join(",")
        }
        this.edit(param);
        this.colVisible = false;
      },
      edit (record) {
        // this.langList = [...this.$store.getters.languagelist];
        // this.langList = Vue.util.extend([],this.$store.getters.languagelist)
        // this.langList = JSON.parse(JSON.stringify(this.$store.getters.languagelist))
        this.initLangListData();
        this.contentLanglist = [];
        // this.initContentPath();
        // this.initLanguagetemp('EmpContentTbl', 'contentTitle', record.id)
        // this.initLanguagetemp('EmpContentTbl', 'contentSubTitle', record.id)
        // this.initLanguagetemp('EmpContentTbl', 'remark', record.id)
        this.model = Object.assign({}, record);
        this.visible = true;
        this.colVisible = true;
        this.entranceId = record.entranceId
        // this.getColList();
        if(this.colidProps!=null){
          //从栏目进来维护就自动选中
          // this.getColInfo(this.colidProps);
          // this.initColsDataEdit(this.colidProps);
          this.isDisable=true;
        }
        if(record.id!=null) {
          this.contentLangCodes = this.model.contentLanguage?this.model.contentLanguage.split(','):[];
          /*if(!!this.contentLangCodes&&this.contentLangCodes.length>0){
            for(let i=0;i<this.langList.length;i++){
              if(this.langList[i].value == this.contentLangCodes[0]){
                // this.TabsActiveKey = i;
                this.changeTabs(i);
                break;
              }
            }
          }*/
          //初始化栏目
          // this.initColsDataEdit(record.colId);
          this.initContentDetails(record.id);
          this.initContentFiles(record.id);
          if ("0" == record.isFilecontent) {
            // this.initContentDetails(record.id);
            // this.initContentFiles(record.id);
            this.contentTypeChecked=true;
            this.contentFileChecked=false;
          }else{
            // this.initContentFiles(record.id);
            this.contentTypeChecked=false;
            this.contentFileChecked=true;
          }
          // this.contentLanglist = this.model.detailsList
        }else{
          this.contentLanglist = [...this.langList]
        }
        this.contentLangCodesOld = [...this.contentLangCodes]
        if(this.$store.getters.applicationCode=='hhemp'){
          this.initLegalpersonList();
        }
      },
      /*getColInfo(colId){
        let that = this
        httpAction("/hhemp/col/cmscoltbl/"+colId, "", "get").then((res) => {
          if (res.success) {
            that.entranceId=res.result.entranceId;
            that.model.entranceId=that.entranceId;
            // const c = that.entrancelist.filter(entrance => entrance.id === that.entranceId)[0].entranceName
            // that.contentPath = that.contentPath+c;
            that.getColList();
          }
        })
      },*/
      /*initColsDataEdit(colId){

        getAction("/hhemp/col/cmscoltbl/"+colId).then((res) => {
          if (res.success) {
            //一級欄目和二級欄目賦值
            if(res.result.colLevel=="1"){
              this.model.firstColId=colId;
              this.classificationId="";
              this.isShowClassification=false;
            }else{
              this.model.firstColId=res.result.parentColId;
              this.classificationId=colId;
              this.isShowClassification=true;
              this.initClassification();
            }
          }
        });
      },*/
      initContentDetails(contentId){
        getAction("/hhemp/contentdetails/empcontentdetailsvo/all",{contentId:contentId}).then((res) => {
          if (res.success) {
            console.log("this,model：",this.model);
            let that=this;
            for(let i=0;i<that.langList.length;i++){
              let boo = false;
              for(let j=0;j<res.result.length;j++){
                let item = res.result[j];
                if(that.langList[i].value == item.langCode){
                  item.value=item.langCode;
                  let contentInfos = JSON.parse(item.contentInfo);
                  item.serviceName =contentInfos.serviceName
                  item.serviceUrl =contentInfos.serviceUrl
                  item.defaultImgUrl =contentInfos.defaultImgUrl
                  item.hoverImgUrl =contentInfos.hoverImgUrl
                    /*let contentInfos = item.contentInfo.split(",");
                    contentInfos.forEach(entity=>{
                      if('question'==entity.split("=")[0]){
                        item.question = entity.split("=")[1];
                      }else if('answer'==entity.split("=")[0]){
                        item.answer = entity.split("=")[1];
                      }
                    })*/
                  that.contentLanglist.push(item)
                  boo = true;
                  break;
                }
              }
              if(!boo){
                that.contentLanglist.push(that.langList[i])
              }
            }
            if(that.contentLangCodes.length!=0){
              that.TabsActiveKey = 0
            }
            /*res.result.forEach(item => {

              let foundObject = that.langList.find(function(obj) {
                return obj.value === item.langCode;
              });
              if(foundObject!=null){
                that.model[foundObject.content]=item.contentDetails;
              }
            })*/
          }
        });
      },
      initContentFiles(contentId){
        getAction("/hhemp/contentfile/empcontentfiles/all",{contentId:contentId}).then((res) => {
          if (res.success) {
            console.log(res)
            let that=this;
            res.result.forEach(item => {

              let foundObject = that.langList.find(function(obj) {
                return obj.value === item.languageCode;
              });
              if(foundObject!=null){
                that.model[foundObject.filePath]=item.filePath;
              }
            })
          }
          //console.log("this model file:",that.model)

        });
      },
      submitForm () {
        const that = this;
        if(that.contentLangCodes.length==0){
          that.$message.error(that.language['emp.content.Q&ADetails']+that.language['common.cannotEmpty'])
          return;
        }
        let boo = true
        // if(!that.model.sortNo||!that.model.legalPerson){
        //   boo = false;
        // }
        if(!that.model.sortNo){
          boo = false;
        }
        for(let i=0;i<that.contentLanglist.length;i++){
          let item = that.contentLanglist[i];
          if(!item.serviceName&&that.contentLangCodes.indexOf(item.value)!=-1){
            that.TabsActiveKey = i;
            boo = false;
            break
          }
          if(!item.serviceUrl&&that.contentLangCodes.indexOf(item.value)!=-1){
            that.TabsActiveKey = i;
            boo = false;
            break
          }
          if(!item.defaultImgUrl&&that.contentLangCodes.indexOf(item.value)!=-1){
            that.TabsActiveKey = i;
            boo = false;
            break
          }
          if(!item.hoverImgUrl&&that.contentLangCodes.indexOf(item.value)!=-1){
            that.TabsActiveKey = i;
            boo = false;
            break
          }
        }
        if(this.$store.getters.applicationCode=='hhemp'){
          if(!that.contentlegalPerson){
            boo = false;
            that.$message.warning(that.language['column.pleaseChoose']+that.language['legalperson']+"!")
          }
        }else if(this.$store.getters.applicationCode=='vnemp'){
          if(!that.model.factoryCode){
            boo = false;
          }
        }
        // 触发表单验证
        let validateForms = that.$refs.form;
        for(let i=0;i<validateForms.length;i++){
          validateForms[i].validate(valid => {
            if (!valid) {
              // boo = false
              // that.submit();
            }
          })
        }
        that.$refs.formTitle.validate(valid => {
          if (!valid) {
            // boo = false
            // that.submit();
          }
        })
        that.$refs.formOther.validate(valid => {
          if (!valid) {
            // boo = false
            // that.submit();
          }
        })
        if(boo){
          this.submit()
        }
      },
      submit(){
        const that = this;
        that.confirmLoading = true;
        let httpurl = '';
        let method = '';
        if(!this.model.id){
          httpurl+=this.url.add;
          method = 'post';
        }else{
          httpurl+=this.url.edit;
          method = 'put';
        }
        // console.log("this.contentTitleLanguages",this.contentTitleLanguages)
        // console.log("this.remarkLanguages",this.remarkLanguages)
        // console.log("this.contentSubTitleLanguages",this.contentSubTitleLanguages)

        // this.contentTitleLanguages.forEach(item => {
        //   item.langCode= item.templateLangCode;
        // })
        // this.contentSubTitleLanguages.forEach(item => {
        //   item.langCode= item.templateLangCode;
        // })
        //
        // this.remarkLanguages.forEach(item => {
        //   item.langCode= item.templateLangCode;
        // })

        this.model.contentTitleLanguages=this.contentTitleLanguages;
        this.model.contentSubTitleLanguages=this.contentSubTitleLanguages;
        this.model.remarkLanguages=this.remarkLanguages;


        this.model.contentLanguages=[];
        let detailsList = [];
        this.contentLanglist.forEach(item => {
          if(this.contentLangCodes.indexOf(item.value)!=-1){
            // item.contentInfo = "question<:=>"+item.question+"<:=:>"+"answer<:=>"+item.answer
            item.contentInfo = JSON.stringify({serviceName:item.serviceName,serviceUrl:item.serviceUrl,defaultImgUrl:item.defaultImgUrl,hoverImgUrl:item.hoverImgUrl});
            let langObj={...item};
            langObj.langCode=item.value;
            langObj.contentTitle=item.serviceName;
            // langObj.contentSubTitle=item.contentSubTitle;
            // langObj.imgUrl=item.imgUrl;
            // langObj.contentDetails=item.contentDetails;
            // langObj.filePath=item.filePath;
            detailsList.push(langObj)
          }
        })
        this.model.detailsList = [...detailsList]
        this.model.contentLanguage = this.contentLangCodes.join(',')


        /*if( this.isShowClassification){
          this.model.colId=this.classificationId;
        }else{
          this.model.colId=this.model.firstColId;
        }*/
        this.model.colId=this.colidProps
        if(this.$store.getters.applicationCode=='hhemp'){
          this.model.legalPersonValuelist = [this.contentlegalPerson];
          if(this.withOutsourcing){
            this.model.legalPersonValuelist.push(this.contentlegalPerson+"_withOutsourcing")
          }
        }



        console.log("this.model:",this.model)
        // return ;
        httpAction(httpurl,this.model,method).then((res)=>{
          if(res.success){
            that.$message.success(res.message);
            that.$emit('ok');
          }else{
            that.$message.warning(res.message);
          }
        }).finally(() => {
          that.confirmLoading = false;
        })
      },
      /*validateToSortNo(rule, value, callback){
        if(value<1||value>9999){
          callback("输入的值在1到9999之间！");
        }
      },*/
      /*getColList(){
        if(!!this.entranceId){
          getAction("/hhemp/col/cmscoltbls/queryallListByLevel", {colLevel:'1',entranceId:this.entranceId}).then((res) => {
            if (res.success) {
              this.cols = res.result;
            }
          })
        }
      },*/
      /*colChange(v,data){
        this.colId = v;
        this.model.colId = v;
        let item = this.cols.find(item => item.id === v);
        if(item&&item.colLevel == '1'&&item.templateType=='1'){
          this.isShowClassification = true;
          this.initClassification();
        }else{
          this.classificationId = '';
          this.isShowClassification = false;
        }
      },*/
      /*initClassification(){
        getAction("/hhemp/col/getChildrenCmscoltbls", {parentColId:this.model.firstColId,publishStatus:'published'}).then((res) => {
          if (res.success) {
            this.classifications = res.result;
          }
        })
      },*/
      /*classificationChange(v){
        this.classificationId = v;
      },*/
      filecontentChange(){

      },
      getNowTime() {
        var date = new Date();
        //年 getFullYear()：四位数字返回年份
        var year = date.getFullYear();  //getFullYear()代替getYear()
        //月 getMonth()：0 ~ 11
        var month = date.getMonth() + 1;
        //日 getDate()：(1 ~ 31)
        var day = date.getDate();
        //时 getHours()：(0 ~ 23)
        var hour = date.getHours();
        //分 getMinutes()： (0 ~ 59)
        var minute = date.getMinutes();
        //秒 getSeconds()：(0 ~ 59)
        var second = date.getSeconds();

        return year + '-' + this.addZero(month) + '-' + this.addZero(day) + ' ' + this.addZero(hour) + ':' + this.addZero(minute) + ':' + this.addZero(second);
      },
      addZero(s) {
        return s < 10 ? ('0' + s) : s;
      },
    }
  }
</script>
<style scoped lang="less">
  .upload-class{
    margin-top: 20px;
  }
  .factoryClass{
    /deep/ .ant-checkbox-wrapper{
      margin-left: 0px !important;
      margin-right: 8px !important;
    }
  }
</style>
